import { API_BASE, authFetch, readJson } from "./base";
import type { ReviewProjection } from "./projection-types";

export async function getReviewProjection(): Promise<ReviewProjection> {
  const response = await authFetch(`${API_BASE}/projections/review`);
  return readJson<ReviewProjection>(response, "Failed to load review projection");
}
